
import {
    FETCH_MANAGER_ANALYTIC_REQUEST,
    FETCH_MANAGER_ANALYTIC_SUCCESS,
    FETCH_MANAGER_ANALYTIC_FAILURE
} from '../../../../../Constants/actionTypes';

const initialState = {
    loading: false,
    result: {},
    error: null,
};

const managerAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MANAGER_ANALYTIC_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_MANAGER_ANALYTIC_SUCCESS:
            const { filter, data } = action.payload; // Expect filter to be included in payload
            return {
                ...state,
                loading: false,
                result: {
                    ...state.result,
                    [filter]: data // Store data for the specific range
                }
            };
        case FETCH_MANAGER_ANALYTIC_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default managerAnalyticsReducer;
